import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AutocompleteField_su from "elements/AutocompleteField_su";
import { Dropdown, Form } from "semantic-ui-react";

interface TaxesFiltersProps {
    filters: {
        country: any;
        region: any;
        city: any;
        category: string;
        tax_type: any;
    };
    onFiltersChange: (filters: any) => void;
    showFilters: boolean;
    onToggleFilters: () => void;
}

export default function TaxesFilters({ filters, onFiltersChange, showFilters, onToggleFilters }: TaxesFiltersProps) {
    
    // Handle cascading clear logic when country changes
    const handleCountryChange = (value: any) => {
        onFiltersChange({
            ...filters,
            country: value,
            region: value ? filters.region : null,  // Clear region if country is cleared
            city: value ? filters.city : null       // Clear city if country is cleared
        });
    };
    
    // Handle cascading clear logic when region changes
    const handleRegionChange = (value: any) => {
        onFiltersChange({
            ...filters,
            region: value,
            city: value ? filters.city : null       // Clear city if region is cleared
        });
    };
    
    const handleCityChange = (value: any) => {
        onFiltersChange({
            ...filters,
            city: value
        });
    };
    
    const handleCategoryChange = (value: any) => {
        onFiltersChange({
            ...filters,
            category: value
        });
    };
    
    const handleTaxTypeChange = (value: any) => {
        onFiltersChange({
            ...filters,
            tax_type: value
        });
    };

    return (
        <>
            <div className="filter-panel">
                <div className="input_row">

                    <AutocompleteField_su
                        label="Country"
                        value={filters.country}
                        onChange={handleCountryChange}
                        endpoint="/countries/getCountriesV2"
                        fullWidth
                        size="small"
                        allowClear={true}
                    />

                    <AutocompleteField_su
                        label="State/Region"
                        value={filters.region}
                        onChange={handleRegionChange}
                        endpoint="/countries/getRegions"
                        endpoint_params={filters.country ? { country_id: typeof filters.country === 'object' ? filters.country.value : filters.country } : {}}
                        fullWidth
                        size="small"
                        disabled={!filters.country}
                        allowClear={true}
                    />

                    <AutocompleteField_su
                        label="City"
                        value={filters.city}
                        onChange={handleCityChange}
                        endpoint="/shipping/zones/getCities"
                        endpoint_params={filters.region ? { region_id: typeof filters.region === 'object' ? filters.region.value : filters.region } : {}}
                        fullWidth
                        size="small"
                        disabled={!filters.region}
                        allowClear={true}
                    />

                    <AutocompleteField_su
                        label="Category"
                        value={filters.category}
                        onChange={handleCategoryChange}
                        endpoint="/admin/taxes/categories/list"
                        fullWidth
                        size="small"
                        allowClear={true}
                    />

                    <AutocompleteField_su
                        label="Tax Type"
                        value={filters.tax_type}
                        onChange={handleTaxTypeChange}
                        endpoint="/admin/taxes/types/list"
                        fullWidth
                        size="small"
                        allowClear={true}
                    />

                </div>
            </div>
        </>
    );
}
